__webpack_require__.p = "/gamingheroes/";